<ng-container [formGroup]="form">
    <p-autoComplete
        *ngIf="show"
        #titleSearch
        [suggestions]="$orgTextSearchFilterBehaviourSubject | async"
        (completeMethod)="searchPosition($event)"
        (onSelect)="positionOnChange($event?.value)"
        minLength="3"
        maxlength="50"
        [formControlName]="formControlNameTitle"
        placeholder="{{ 'autocompleteSearchText' | translate | uppercase }}"
        [showEmptyMessage]="true"
        emptyMessage="{{ 'noRecordsFound' | translate }}"
        [forceSelection]="true"
        [delay]="500"
        appendTo="body"
        [optionValue]="'value'"
        [optionLabel]="'label'"
        field="label"
        [dropdown]="true"
    >
    </p-autoComplete>

</ng-container>
